var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { FlushDocumentSessionDocument } from './FlushDocumentSession.gql';
/**
 * This hook will flush all sessions for a specific document ID
 * @returns
 */
export function useFlushDocument() {
    const [mutation, state] = useMutation(FlushDocumentSessionDocument);
    const handleMutation = useCallback((id) => __awaiter(this, void 0, void 0, function* () {
        return mutation({
            variables: { id },
        });
    }), [mutation]);
    return [handleMutation, state];
}
